import React from "react";

function deleteSmartQuestionaireSleeve({ show, name, deleting, onCancel, onDelete }) {
  if (!show) return null;
  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Delete Smart Questionaire</h5>
            <button type="button" className="btn-close" onClick={onCancel} aria-label="Close">
              <i className="bi bi-x-circle" aria-hidden="true" />
            </button>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to delete <b>{name}</b>?</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={deleting}>Cancel</button>
            <button type="button" className="btn btn-danger" onClick={onDelete} disabled={deleting}>{deleting ? 'Deleting...' : 'Delete'}</button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </div>
  );
}

export default deleteSmartQuestionaireSleeve; 